'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { useTracker } from '@lichtblick/tracker';
import { type FC, useContext, useEffect } from 'react';
import { useFormStatus } from 'react-dom';
import { ErrorBanner } from '@/components/error-banner/error-banner';
import { ErrorContext } from '@/components/error-boundary/error-boundary';
import { i18n } from '@/i18n';

interface SubmitButtonProps {
  'data-testid'?: string;
  disabled?: boolean;
  error?: string;
  label?: string;
  loading?: boolean;
  trackingName: string;
}

export const SubmitButton: FC<SubmitButtonProps> = ({
  'data-testid': dataTestId = 'button-submit',
  disabled,
  error,
  label = i18n.form.submit,
  loading,
  trackingName,
}) => {
  const { trackCustomEvent } = useTracker();
  const { outerError } = useContext(ErrorContext);
  const { pending } = useFormStatus();
  const errorMessage = outerError ? 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.' : error;

  useEffect(() => {
    if (errorMessage) {
      trackCustomEvent({
        eventName: 'form_failed',
        customProps: { form_name: trackingName, error_message: errorMessage },
      });
    }
  }, [errorMessage, trackingName, trackCustomEvent]);

  return (
    <>
      {errorMessage && !pending && <ErrorBanner>{errorMessage}</ErrorBanner>}
      <BoxCTA as="button" data-testid={dataTestId} disabled={disabled} loading={loading || pending} type="submit">
        {label}
      </BoxCTA>
    </>
  );
};
